import { render } from "./LecturesArticleSection.vue?vue&type=template&id=2c6a4ecb"
import script from "./LecturesArticleSection.vue?vue&type=script&lang=js"
export * from "./LecturesArticleSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__